import styled, { keyframes } from "styled-components";

import theme from "../../theme";

export const brickPop = keyframes`
    0% { opacity: 0; transform: translateY(10px) scale(0.85); }
    15%, 65% { opacity: 1; transform: translateY(0) scale(1); }
    85%, 100% { opacity: 0; transform: translateY(-4px) scale(0.92); }
`;

export const logoPulse = keyframes`
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.92; transform: scale(1.03); }
`;

export const textFade = keyframes`
    0% { opacity: 0; transform: translateY(4px); }
    15%, 85% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-4px); }
`;

export const barSlide = keyframes`
    0% { transform: translateX(-100%); }
    100% { transform: translateX(350%); }
`;

export const Wrapper = styled.div`
    display: flex;
    position: fixed;
    inset: 0;
    z-index: 99999999;
    align-items: center;
    justify-content: center;
    background: #fff;
`;

export const Inner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.75rem;
    padding: 1.5rem;
    text-align: center;
`;

export const Logo = styled.img`
    width: 160px;
    max-width: 160px;
    height: 55px;
    object-fit: contain;
    animation: ${logoPulse} 2s ease-in-out infinite;
`;

export const Wall = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 34px);
    grid-auto-rows: 16px;
    gap: 3px;
`;

export const Brick = styled.div<{ $delay: number; $color: string }>`
    width: 34px;
    height: 16px;
    border-radius: 2px;
    background: ${({ $color }) => $color};
    box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.12);
    animation: ${brickPop} 2.8s ease-in-out infinite;
    animation-delay: ${({ $delay }) => $delay}s;
`;

export const Bar = styled.div`
    width: 200px;
    height: 4px;
    border-radius: 2px;
    background: #e2e8f0;
    overflow: hidden;
`;

export const BarFill = styled.div`
    height: 100%;
    width: 40%;
    border-radius: 2px;
    background: ${() => theme.palette.primary.main};
    animation: ${barSlide} 1.4s ease-in-out infinite;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: #1e293b;
    font-family: "Nunito", sans-serif;
`;

export const Message = styled.p`
    margin: 0;
    min-height: 1.25rem;
    font-size: 0.9rem;
    font-weight: 500;
    color: #64748b;
    letter-spacing: 0.01em;
    animation: ${textFade} 2.6s ease-in-out;
`;

export const HintText = styled.p`
    margin: 0;
    font-size: 0.78rem;
    color: #94a3b8;
`;

export const CloseButton = styled.button`
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #475569;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 0.4rem 0.9rem;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
        background: #f8fafc;
    }
`;
